<template>
  <div class="ecm__checkbox">
    <input :disabled="isDisabled"
      type="checkbox"
      id="check"
      v-model="isChecked"
      checked="value"
    >
    <label :class="[label ? 'margin' : '']">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    value: [Boolean],
    label: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isChecked: {
      get () {
        return this.$props.value
      },
      set (e) {
        this.$emit('input', e)
        this.$emit('change', e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__checkbox {
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: default;
  input[type="checkbox"] {
    border: 2px solid var(--color-blue-background);
    appearance: none;
    -webkit-appearance: none;
    height: 15px;
    width: 15px;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    transition: .1s;
    &:after {
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      content: "\f00c";
      font-size: 10px;
      color: white;
      opacity: 0;
      transition: .1s;
    }
    &:checked {
      background: var(--color-blue-background);
    }
    &:checked:after {
      opacity: 1;
    }
    &:disabled {
      cursor: default;
    }
  }
  label {
    font-size: 15px;
    &.margin {
      margin-left: 5px;
    }
  }
}

@media screen and (max-width: 1024px) {
  .ecm__checkbox {
    input[type="checkbox"] {
      height: 17px;
      width: 17px;
    }
    label {
      font-size: 16px;
      &.margin {
        margin-left: 3px;
      }
    }
  }
}

@media screen and (max-width: 481px) {
  .ecm__checkbox {
    input[type="checkbox"] {
      height: 17px;
      width: 17px;
    }
    label {
      font-size: 15px;
      &.margin {
        margin-left: 3px;
      }
    }
  }
}
</style>
